export const districts = {
    'Таласская': "ТАЛАССКАЯ ТИК",
    'г.Ош' : 'ОШ Г.',
    'Ошская' : 'ОШСКАЯ ОБЛАСТЬ',
    'Нарынская' : 'НАРЫНСКАЯ ОБЛАСТЬ',
    'Джалал-Абадская' : 'ДЖАЛАЛ-АБАДСКАЯ ОБЛАСТЬ',
    'Иссык-Кульская' : 'ЫСЫК-КУЛЬСКАЯ ОБЛАСТЬ',
    'Чуйская' : 'ЧУЙСКАЯ ОБЛАСТЬ', 
    'г.Бишкек' : 'БИШКЕК Г.',
    'Баткенская' :  'БАТКЕНСКАЯ ОБЛАСТЬ'
}

export const districtsShow = {
    'ТАЛАССКАЯ ТИК': "Таласская область",
    'ОШ Г.' : 'г. Ош',
    'ОШСКАЯ ОБЛАСТЬ' : 'Ошская область',
    'НАРЫНСКАЯ ОБЛАСТЬ' : 'Нарынская область',
    'ДЖАЛАЛ-АБАДСКАЯ ОБЛАСТЬ' : 'Джалал-Абадская область',
    'ЫСЫК-КУЛЬСКАЯ ОБЛАСТЬ' : 'Ысык-Кульская область',
    'ЧУЙСКАЯ ОБЛАСТЬ' : 'Чуйская область', 
    'БИШКЕК Г.' : 'г. Бишкек',
    'БАТКЕНСКАЯ ОБЛАСТЬ' :  'Баткенская область'
}

export const matchDistrict = (title) => {
    if (title in districts) {
        return districts[title]
    }
    else {
        return title
    }      
}

export const matchDistrictShow = (title) => {
    if (title in districtsShow) {
        return districtsShow[title]
    }
    else {
        return title
    }      
}

export default matchDistrict;